import React, { useEffect, useState } from "react";
import Label from "../ui-components/Label";
import {
  PencilIcon,
  TrashIcon,
  CheckIcon,
  XMarkIcon,
} from "@heroicons/react/24/solid";
import Button from "../ui-components/Button";
import MoveBlock from "./MoveBlock";
import Input from "../ui-components/Input";
import _ from "lodash";
import { FormattedMessage, useIntl } from "react-intl";

const ServiceConfiguratorAlertTCSQuestions = ({ metadata_, setMetadata }) => {
  const intl = useIntl();
  const [questions, setQuestions] = useState(
    _.cloneDeep(metadata_.questions)
  );
  // If the index has match open it otherwise not
  const [openQuestionIndex, setOpenQuestionIndex] = useState(-1);
  const [tmpQuestion, setTmpQuestion] = useState({ text: "", name: "" });

  useEffect(() => {
    let _metadata_ = _.cloneDeep(metadata_);
    _metadata_.questions = questions;
    setMetadata(_metadata_);
  }, [questions]);

  const moveBlock = (questions, position1, position2) => {
    if (
      position1 < 0 ||
      position1 >= questions.length ||
      position2 < 0 ||
      position2 >= questions.length
    ) {
      throw new Error("Invalid positions");
    }

    setQuestions((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];
      const [movedItem] = updatedQuestions.splice(position1, 1);
      updatedQuestions.splice(position2, 0, movedItem);
      return updatedQuestions;
    });
  };

  const deleteQuestion = (index) => {
    // Corrected function name
    setQuestions((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];
      updatedQuestions.splice(index, 1);
      return updatedQuestions;
    });
  };

  const saveQuestion = (index) => {
    // Added save function
    setQuestions((prevQuestions) => {
      const updatedQuestions = [...prevQuestions];
      updatedQuestions[index] = tmpQuestion;
      return updatedQuestions;
    });
    setOpenQuestionIndex(-1);
    setTmpQuestion({ text: "", name: "" });
  };

  const cancelEdit = () => {
    // Added cancel function
    setOpenQuestionIndex(-1);
    setTmpQuestion({ text: "", name: "" });
  };

  return (
    <div className="flex w-full flex-col mb-4">
      <Label>
        <FormattedMessage
          id="additional_questions"
          defaultMessage={intl.formatMessage({
            id: "additional_questions",
            defaultMessage: "Domande aggiuntive",
          })}
        />
      </Label>
      <div className="mb-2" />
      {questions.map((question, index) => {
        const active = index === openQuestionIndex ? "bg-gray-200" : "";
        return (
          <div
            key={index}
            className={`flex w-full justify-center items-center rounded border border-gray mt-2 mb-2 p-1.5 ${active}`}
          >
            <div className="flex items-center w-1/6">
              <MoveBlock
                listLength={questions.length}
                moveBlock={moveBlock}
                position={index}
                block={question}
              />
            </div>
            <div className="flex flex-col w-5/6">
              {openQuestionIndex === index ? (
                <>
                  <Input
                    className="w-full"
                    value={tmpQuestion.name} // Updated to use tmpQuestion
                    onChange={(e) => {
                      setTmpQuestion((prevQuestion) => ({
                        ...prevQuestion,
                        name: e.target.value,
                      }));
                    }}
                    label={intl.formatMessage({id: "name", defaultMessage: "Nome"})}
                    type="text"
                  />
                  <p className="mb-2">
                    <FormattedMessage
                      id="question_text"
                      defaultMessage={intl.formatMessage({
                        id: "question_text",
                        defaultMessage: "Testo domanda",
                      })}
                    />
                  </p>
                  <textarea
                    className={`px-2 py-2 pr-10 border shadow-sm focus:ring-am-500 focus:border-am-500 block w-full sm:text-sm border-gray-300 rounded-md disabled:opacity-50`}
                    rows={4}
                    value={tmpQuestion.text} // Updated to use tmpQuestion
                    onChange={(e) => {
                      setTmpQuestion((prevQuestion) => ({
                        ...prevQuestion,
                        text: e.target.value,
                      }));
                    }}
                  />
                </>
              ) : (
                <p>{question.name}</p>
              )}
            </div>
            <div className="flex items-center w-1/6 justify-end">
              {openQuestionIndex === index ? (
                <>
                  <div
                    onClick={() => saveQuestion(index)} // Updated to call saveQuestion
                    className="w-7 h-7 mr-2 cursor-pointer text-green-600"
                  >
                    <CheckIcon />
                  </div>
                  <div
                    onClick={() => cancelEdit()} // Updated to call cancelEdit
                    className="w-7 h-7 cursor-pointer text-red-600"
                  >
                    <XMarkIcon />
                  </div>
                </>
              ) : (
                <>
                  <div
                    onClick={() => {
                      setTmpQuestion({ ...question });
                      setOpenQuestionIndex(index);
                    }}
                    className="w-7 h-7 mr-2 cursor-pointer text-gray-400"
                  >
                    <PencilIcon />
                  </div>
                  <div
                    onClick={() => deleteQuestion(index)} // Corrected function name
                    className="w-7 h-7 cursor-pointer text-red-600"
                  >
                    <TrashIcon />
                  </div>
                </>
              )}
            </div>
          </div>
        );
      })}
      <div className="flex w-full justify-end mt-4">
        <Button
          onClick={() => {
            setQuestions([...questions, { text: "", name: `Nome domanda` }]);
          }}
        >
          <FormattedMessage
            id="add_question"
            defaultMessage={intl.formatMessage({
              id: "add_question",
              defaultMessage: "Aggiungi domanda",
            })}
          />
        </Button>
      </div>
    </div>
  );
};

export default ServiceConfiguratorAlertTCSQuestions;
